"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsplashCollection = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var UnsplashCollection = (function (_super) {
    __extends(UnsplashCollection, _super);
    function UnsplashCollection(props) {
        var _this = _super.call(this, props) || this;
        _this.hasImageLoaded = false;
        _this.handleImageLoaded = function () {
            var collection = _this.props.collection;
            var img = new window.Image();
            img.onload = _this.setHasImageLoaded;
            img.src = collection.thumbnailUrl;
        };
        _this.setHasImageLoaded = function () {
            _this.hasImageLoaded = true;
        };
        _this.onSelectItem = _this.onSelectItem.bind(_this);
        return _this;
    }
    UnsplashCollection.prototype.componentDidMount = function () {
        this.handleImageLoaded();
    };
    UnsplashCollection.prototype.render = function () {
        var collection = this.props.collection;
        return (react_1.default.createElement("div", { className: "unsplash-collection" },
            react_1.default.createElement("div", { className: "unsplash-collection__header" },
                react_1.default.createElement("span", { className: "unsplash-collection__title" }, collection.title),
                react_1.default.createElement("span", { className: "unsplash-collection__count" },
                    "(",
                    collection.count,
                    ")")),
            react_1.default.createElement("div", { className: (0, classnames_1.default)({
                    "unsplash-collection__image_loaded": this.hasImageLoaded,
                    "unsplash-collection__image": true,
                }), style: { backgroundImage: this.hasImageLoaded ? "url(".concat(collection.thumbnailUrl, ")") : "" } },
                react_1.default.createElement("div", { className: "unsplash-collection__overlay", onClick: this.onSelectItem },
                    react_1.default.createElement(kaleidoscope_1.Button, { className: "unsplash-collection__select-item", size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Secondary }, "View collection"),
                    this.renderSecondaryAction()))));
    };
    UnsplashCollection.prototype.onSelectItem = function () {
        var _a = this.props, collection = _a.collection, onSelectCollection = _a.onSelectCollection;
        onSelectCollection(collection);
    };
    UnsplashCollection.prototype.renderSecondaryAction = function () {
        var _a = this.props, secondaryAction = _a.secondaryAction, collection = _a.collection;
        if (!secondaryAction) {
            return;
        }
        var handleButtonClick = function (event) {
            event.stopPropagation();
            secondaryAction.onClick(collection);
        };
        return (react_1.default.createElement(kaleidoscope_1.Button, { className: (0, classnames_1.default)(tokens_1.darkTheme, "unsplash-collection__secondary-action"), size: kaleidoscope_1.ButtonSize.XSmall, type: kaleidoscope_1.ButtonType.Tertiary, onClick: handleButtonClick }, secondaryAction.label));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], UnsplashCollection.prototype, "hasImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], UnsplashCollection.prototype, "handleImageLoaded", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Object)
    ], UnsplashCollection.prototype, "setHasImageLoaded", void 0);
    UnsplashCollection = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], UnsplashCollection);
    return UnsplashCollection;
}(react_1.default.Component));
exports.UnsplashCollection = UnsplashCollection;
